module.exports = __webpack_public_path__ + "static/media/yellow-bg-landscape.4e6ec390.webp";